export default "__VITE_ASSET__C$FJivaP__"